module.exports = __webpack_public_path__ + "img/fr.e59c82fc.svg";